import { Component, Vue } from 'vue-property-decorator'
import { evaluationExcelSyncHistory } from '@/api'
import urlBase from '@/utils/urlBase'
import moment from 'moment'

@Component({ name: 'apply-add' })
export default class ApplyAdd extends Vue {
  private list: any = []
  private loading = false
  private modify: any= {
    // url: 'http://192.168.0.33:10069/teacherAdmin/mentor/import'
    url: urlBase.eduBaseUrl + '/evaluationExcelSync/import'
  }

  created () {
    this.initPageData()
  }

  private async initPageData () {
    const result: any = await evaluationExcelSyncHistory({})
    this.list = result.result
  }

  private async handleModifySuccess (response: any) {
    if (response.error.returnCode === 0) {
      this.$message({
        type: 'success',
        message: '导入成功!'
      })
      // this.list = response.data.result
      this.initPageData()
    } else {
      this.$message({
        type: 'error',
        message: response.error.returnMessage
      })
    }
    this.loading = false
    const upload: any = this.$refs.upload
    upload.clearFiles()
  }

  private async handleModifyError () {
    this.$message({
      type: 'error',
      message: '导入失败!'
    })
    const upload: any = this.$refs.upload
    upload.clearFiles()
    this.loading = false
  }

  private async beforeUpload () {
    this.loading = true
  }

  private downloadTemplate () {
    const url: any = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/evaluationImport/%E6%A8%A1%E6%9D%BF.xls'
    const a: any = document.createElement('a')
    a.href = url //  URL对象
    a.click() // 模拟点击
  }

  private downloaderror (row: any) {
    const url: any = row.errorExcelUrl
    const a: any = document.createElement('a')
    a.href = url //  URL对象
    a.click() // 模拟点击
  }
}
